import React from 'react';
import './ComponentCss/ComponyInfoChip.css'; // 스타일을 위한 CSS 파일(Optional)
import homeImage from '../Image/Home.png';
import seemoreImage from '../Image/more.png';

const CompanyInfoChip = ({ name, roomCount,onClick }) => {
    const handleClick = () => {
        if (onClick) {
            onClick(name); // 클릭 시 name 값을 onClick에 전달
        }
    };

    const seemore = (event) => {
        event.stopPropagation(); // 다른 클릭 이벤트 전파를 막음
        alert("Sgewg");
    };

    return (
        <button className="chip" onClick={handleClick}>

            <img className={'image'} src={homeImage} alt="Description of image" />

            <div className={'Text'}> {name}</div>

            {/*<button className={'seemore-box'} onClick={seemore}>*/}
            {/*    <img className={'seemore'} src={seemoreImage} alt="See more" />*/}
            {/*</button>*/}

            <div className={'seemore-box'}>
                <div className={'count-box'}>{roomCount}</div>
            </div>
        </button>
    );
};

export default CompanyInfoChip;
